module.exports = __webpack_public_path__ + "static/media/easyToUse.80f6f1ba.svg";